/* Subscription builder — pick a coffee, a size, and a delivery frequency.
   Posts variant id + selling_plan to /cart/add, so Appstle handles billing
   while the storefront experience stays in the theme. */
(function () {
  var roots = document.querySelectorAll('[data-tgsb]');
  Array.prototype.forEach.call(roots, function (root) { init(root); });

  function init(root) {
    var raw = root.querySelector('[data-tgsb-data]');
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }

    // "Limited Release" pill text from theme settings, escaped for the markup below.
    var limitedLabel = String(data.limitedLabel || 'Limited Release').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });

    var products = (data.products || []).filter(function (p) {
      return p.variants.length && p.plans.length;
    });

    var el = {
      stage: root.querySelector('[data-tgsb-stage]'),
      track: root.querySelector('[data-tgsb-track]'),
      prev: root.querySelector('[data-tgsb-prev]'),
      next: root.querySelector('[data-tgsb-next]'),
      name: root.querySelector('[data-tgsb-name]'),
      desc: root.querySelector('[data-tgsb-desc]'),
      learn: root.querySelector('[data-tgsb-learn]'),
      sizes: root.querySelector('[data-tgsb-sizes]'),
      plans: root.querySelector('[data-tgsb-plans]'),
      price: root.querySelector('[data-tgsb-price]'),
      add: root.querySelector('[data-tgsb-add]'),
      summary: root.querySelector('[data-tgsb-summary]'),
      error: root.querySelector('[data-tgsb-error]'),
      empty: root.querySelector('[data-tgsb-empty]'),
      dots: root.querySelector('[data-tgsb-dots]'),
      recall: root.querySelector('[data-tgsb-recall]'),
      recallImg: root.querySelector('[data-tgsb-recall-img]'),
      recallName: root.querySelector('[data-tgsb-recall-name]'),
      qty: root.querySelector('[data-tgsb-qty]'),
      qtyUp: root.querySelector('[data-tgsb-qty-up]'),
      qtyDown: root.querySelector('[data-tgsb-qty-down]'),
      grind: root.querySelector('[data-tgsb-grind]'),
      grindGroup: root.querySelector('[data-tgsb-grind-group]')
    };

    if (!products.length) {
      el.empty.hidden = false;
      el.stage.hidden = true;
      return;
    }

    var money = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: data.currency || 'USD'
    });

    var state = { p: 0, v: null, plan: null, qty: 1, grind: null };
    var kiosk = root.hasAttribute('data-tgsb-kiosk');
    // Until the shopper picks a coffee, no bag is singled out: highlighting the
    // first one on load made the rest look sold out.
    var hasPicked = false;

    // Scroll the next step into view once one is answered, so the flow reads as
    // a sequence on a phone rather than a page you have to hunt down.
    var steps = {
      pick: root.querySelector('.tgsb__step--pick'),
      size: el.sizes.closest('.tgsb__row'),
      plan: el.plans.closest('.tgsb__row'),
      pay: root.querySelector('.tgsb__checkout')
    };

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markCurrent(key) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].classList.toggle('is-current', k === key);
      });
    }

    function advanceTo(key) {
      var target = steps[key];
      if (!target) return;
      markCurrent(key);
      // Only take over scrolling on narrow screens; on desktop the whole
      // builder is visible at once and moving the page would be jarring.
      if (!kiosk && window.innerWidth > 820) return;
      window.setTimeout(function () {
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center'
        });
      }, 180);
    }

    // ---- rendering -------------------------------------------------------

    products.forEach(function (p, i) {
      var li = document.createElement('li');
      li.className = 'tgsb__slide';
      li.innerHTML =
        '<button type="button" class="tgsb__slide-btn" data-i="' + i + '">' +
          (p.image ? '<img class="tgsb__slide-img" src="' + p.image + '" alt="" loading="lazy" width="400" height="400">' : '<span class="tgsb__slide-img"></span>') +
          (p.limited ? '<span class="tg-limited">' + limitedLabel + '</span>' : '') +
          '<span class="tgsb__slide-title"></span>' +
        '</button>';
      li.querySelector('.tgsb__slide-title').textContent = p.title;
      el.track.appendChild(li);
    });

    // Dots show how many coffees there are and which one you are looking at.
    // They follow the scroll position rather than the selection, because the
    // arrows browse without selecting — tying them to selection would leave
    // them frozen while the carousel moves.
    if (el.dots) {
      products.forEach(function (p, i) {
        var d = document.createElement('span');
        d.className = 'tgsb__dot';
        d.dataset.i = i;
        el.dots.appendChild(d);
      });
    }

    function syncDots() {
      if (!el.dots) return;
      var mid = el.track.scrollLeft + el.track.clientWidth / 2;
      var best = 0;
      var bestGap = Infinity;
      Array.prototype.forEach.call(el.track.children, function (li, i) {
        var centre = li.offsetLeft + li.offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      Array.prototype.forEach.call(el.dots.children, function (d, i) {
        d.classList.toggle('is-active', i === best);
      });
    }

    // --- grind ---------------------------------------------------------------
    // Sent as a line item property under the same name the product page uses,
    // so subscription orders show the grind exactly as one-off orders do.
    var grindChoices = el.grind
      ? (el.grind.getAttribute('data-choices') || '').split(/\r?\n/)
          .map(function (c) { return c.trim(); }).filter(Boolean)
      : [];
    var grindProperty = el.grind ? el.grind.getAttribute('data-property') : '';
    if (grindChoices.length) state.grind = grindChoices[0];

    function scrollStep(target) {
      if (!target || (!kiosk && window.innerWidth > 820)) return;
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }, 180);
    }

    // --- quantity ---------------------------------------------------------

    var qtyMax = el.qty ? (parseInt(el.qty.getAttribute('max'), 10) || 10) : 1;

    function setQty(n) {
      var next = Math.max(1, Math.min(qtyMax, isNaN(n) ? 1 : n));
      state.qty = next;
      if (el.qty) el.qty.value = next;
      if (el.qtyDown) el.qtyDown.disabled = next <= 1;
      if (el.qtyUp) el.qtyUp.disabled = next >= qtyMax;
      renderTotals();
    }

    if (el.qtyUp) el.qtyUp.addEventListener('click', function () { setQty(state.qty + 1); });
    if (el.qtyDown) el.qtyDown.addEventListener('click', function () { setQty(state.qty - 1); });
    if (el.qty) {
      el.qty.addEventListener('change', function () { setQty(parseInt(el.qty.value, 10)); });
      // Typing a value should not fight the field mid-edit, so only clamp on blur.
      el.qty.addEventListener('blur', function () { setQty(parseInt(el.qty.value, 10)); });
    }

    // --- sticky recall bar ------------------------------------------------
    // Visible only while the picker is off screen and the builder still is.
    var stageVisible = true;
    var builderVisible = false;

    function sizeRecall() {
      if (!el.recall) return;
      var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
      var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
      // A non-sticky header scrolls away, so pin to the top instead.
      var pinned = header && header.getBoundingClientRect().top <= 1;
      el.recall.style.setProperty('--tgsb-recall-top', (pinned ? h : 0) + 'px');
    }

    function syncRecall() {
      if (!el.recall) return;
      var show = builderVisible && !stageVisible;
      // Drop the attribute once scripted so the slide can animate; the class
      // and visibility take over from here.
      el.recall.hidden = false;
      sizeRecall();
      el.recall.classList.toggle('is-shown', show);
    }

    if (el.recall && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stageVisible = entries[0].isIntersecting;
        syncRecall();
      }, { threshold: 0 }).observe(el.stage);

      new IntersectionObserver(function (entries) {
        builderVisible = entries[0].isIntersecting;
        syncRecall();
      }, { threshold: 0 }).observe(root);

      window.addEventListener('scroll', sizeRecall, { passive: true });

      el.recall.addEventListener('click', function () {
        el.stage.scrollIntoView({
          block: 'center',
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        markCurrent('pick');
      });
    }

    var dotTick = null;
    el.track.addEventListener('scroll', function () {
      if (dotTick) return;
      dotTick = window.requestAnimationFrame(function () {
        dotTick = null;
        syncDots();
      });
    }, { passive: true });

    el.track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-i]');
      if (btn) selectProduct(parseInt(btn.dataset.i, 10), true);
    });

    el.prev.addEventListener('click', function () { step(-1); });
    el.next.addEventListener('click', function () { step(1); });

    // The arrows browse the carousel only. Choosing a coffee is a deliberate
    // act — tapping a bag — so scrolling past one never changes the order.
    function step(dir) {
      var slides = el.track.children;
      if (!slides.length) return;
      var first = slides[0].getBoundingClientRect();
      var stride = first.width;
      if (slides.length > 1) {
        stride = slides[1].getBoundingClientRect().left - first.left;
      }
      // Wrap at the ends, so paging right past the last coffee returns to the
      // first rather than stopping dead.
      var max = el.track.scrollWidth - el.track.clientWidth;
      var at = el.track.scrollLeft;
      var target;
      if (dir > 0 && at >= max - 2) {
        target = 0;
      } else if (dir < 0 && at <= 2) {
        target = max;
      } else {
        target = Math.max(0, Math.min(max, at + dir * stride));
      }

      el.track.scrollTo({
        left: target,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    function options(container, items, checkedId, nameAttr, onPick) {
      container.innerHTML = '';
      items.forEach(function (item) {
        var id = nameAttr + '-' + String(item.value).replace(/[^a-z0-9_-]/gi, '-');
        var wrap = document.createElement('label');
        wrap.className = 'tgsb__option' + (item.disabled ? ' is-disabled' : '');
        wrap.setAttribute('for', id);
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = nameAttr;
        input.id = id;
        input.value = item.value;
        input.className = 'tgsb__radio';
        if (item.disabled) input.disabled = true;
        if (String(item.value) === String(checkedId)) input.checked = true;
        input.addEventListener('change', function () { onPick(item.value); });
        var text = document.createElement('span');
        text.className = 'tgsb__option-label';
        text.textContent = item.label;
        wrap.appendChild(input);
        wrap.appendChild(text);
        container.appendChild(wrap);
      });
    }

    function currentProduct() { return products[state.p]; }

    function currentVariant() {
      var p = currentProduct();
      return p.variants.filter(function (v) { return String(v.id) === String(state.v); })[0] || p.variants[0];
    }

    function selectProduct(i, userPicked) {
      state.p = i;
      var p = currentProduct();

      if (userPicked) hasPicked = true;
      root.classList.toggle('is-unpicked', !hasPicked);

      Array.prototype.forEach.call(el.track.children, function (li, n) {
        li.classList.toggle('is-selected', hasPicked && n === i);
      });
      // Only recentre when the shopper picked this one. Doing it on first
      // render left the carousel scrolled a little way in, which then
      // compounded with the first arrow click and skipped a coffee.
      var sel = el.track.children[i];
      if (userPicked && sel && sel.scrollIntoView) {
        sel.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      el.name.textContent = p.title;
      el.desc.textContent = p.description;
      el.learn.href = p.url;

      if (el.recallName) el.recallName.textContent = p.title;
      if (el.recallImg && p.image) {
        el.recallImg.src = p.image;
        el.recallImg.alt = '';
      }

      var firstAvailable = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      state.v = firstAvailable.id;

      var stillValid = p.plans.some(function (pl) { return String(pl.id) === String(state.plan); });
      if (!stillValid) state.plan = p.plans[0].id;

      renderChoices();
      if (userPicked) advanceTo('size');
    }

    function renderChoices() {
      var p = currentProduct();

      options(el.sizes, p.variants.map(function (v) {
        return { value: v.id, label: v.title, disabled: !v.available };
      }), state.v, 'tgsb-size-' + p.id, function (val) {
        state.v = val;
        renderTotals();
        if (grindChoices.length) {
          markCurrent('size');
          scrollStep(el.grindGroup);
        } else {
          advanceTo('plan');
        }
      });

      if (el.grind && grindChoices.length) {
        options(el.grind, grindChoices.map(function (c) {
          return { value: c, label: c, disabled: false };
        }), state.grind, 'tgsb-grind-' + p.id, function (val) {
          state.grind = val;
          renderTotals();
          advanceTo('plan');
        });
      }

      options(el.plans, p.plans.map(function (pl) {
        return { value: pl.id, label: pl.name, disabled: false };
      }), state.plan, 'tgsb-plan-' + p.id, function (val) {
        state.plan = val;
        renderTotals();
        advanceTo('pay');
      });

      renderTotals();
    }

    function renderTotals() {
      var p = currentProduct();
      var v = currentVariant();
      var alloc = v.allocations && v.allocations[String(state.plan)];
      var planName = (p.plans.filter(function (pl) { return String(pl.id) === String(state.plan); })[0] || {}).name || '';

      var qty = state.qty || 1;

      if (alloc) {
        var now = money.format((alloc.price * qty) / 100);
        var was = alloc.compare > alloc.price
          ? '<s class="tgsb__was">' + money.format((alloc.compare * qty) / 100) + '</s> '
          : '';
        el.price.innerHTML = was + '<strong>' + now + '</strong>';
      } else {
        el.price.innerHTML = '<strong>' + money.format((v.price * qty) / 100) + '</strong>';
      }

      el.summary.textContent = 'You will get ' + qty + ' \u00d7 ' + p.title + ' — ' + v.title +
        (state.grind ? ', ' + state.grind.toLowerCase() : '') +
        (planName ? ', ' + planName.toLowerCase() + '.' : '.');

      el.add.disabled = !v.available;
      el.add.textContent = v.available ? el.add.dataset.label || el.add.textContent : 'Sold out';
    }

    // ---- add to cart -----------------------------------------------------

    el.add.dataset.label = el.add.textContent;

    // Mirrors Dawn's product-form: post as FormData with the drawer's sections
    // so the cart drawer can re-render and slide open, instead of a page jump.
    var cartUI = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartUI && document.querySelector('cart-drawer')) {
      el.add.setAttribute('aria-haspopup', 'dialog');
    }

    el.add.addEventListener('click', function () {
      var v = currentVariant();
      if (!v.available) return;

      el.error.hidden = true;
      el.add.disabled = true;
      var label = el.add.dataset.label;
      el.add.textContent = 'Adding…';

      var form = new FormData();
      form.append('id', v.id);
      form.append('quantity', state.qty);
      if (state.plan) form.append('selling_plan', state.plan);
      if (grindProperty && state.grind) form.append('properties[' + grindProperty + ']', state.grind);

      if (kiosk) {
        el.add.textContent = 'Opening checkout…';
        clearCart()
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: form
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'Could not start checkout.');
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            el.error.hidden = false;
            el.error.textContent = err.message;
            el.add.disabled = false;
            el.add.textContent = label;
          });
        return;
      }

      if (cartUI) {
        form.append('sections', cartUI.getSectionsToRender().map(function (s) { return s.id; }));
        form.append('sections_url', window.location.pathname);
        cartUI.setActiveElement(document.activeElement);
      }

      var config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = form;

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl, config)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            throw new Error(res.description || res.message || 'Could not add to cart.');
          }
          if (cartUI) {
            cartUI.renderContents(res);
          } else {
            window.location.href = ((window.routes && window.routes.cart_url) || '/cart');
            return;
          }
          el.add.disabled = false;
          el.add.textContent = label;
        })
        .catch(function (err) {
          el.error.hidden = false;
          el.error.textContent = err.message;
          el.add.disabled = false;
          el.add.textContent = label;
        });
    });

    selectProduct(0, false);
    setQty(1);
    markCurrent('pick');
    syncDots();

    // ---- cafe kiosk --------------------------------------------------------
    // One iPad, many customers: every visit starts with an empty cart and the
    // builder back at step 1, including after sitting idle or returning from
    // checkout with the back button.
    if (kiosk) {
      var idleMs = (parseInt(root.getAttribute('data-tgsb-kiosk'), 10) || 90) * 1000;
      var idleTimer = null;
      var touched = false;

      var resetBuilder = function () {
        touched = false;
        state.plan = null;
        state.grind = grindChoices.length ? grindChoices[0] : null;
        el.error.hidden = true;
        el.add.disabled = false;
        el.add.textContent = el.add.dataset.label;
        selectProduct(0, false);
        setQty(1);
        markCurrent('pick');
        el.track.scrollTo({ left: 0, behavior: 'auto' });
        window.scrollTo({ top: 0, behavior: 'auto' });
        syncDots();
        clearCart();
      };

      var armIdle = function () {
        touched = true;
        window.clearTimeout(idleTimer);
        idleTimer = window.setTimeout(function () {
          if (touched) resetBuilder();
        }, idleMs);
      };

      ['pointerdown', 'keydown', 'touchstart'].forEach(function (type) {
        document.addEventListener(type, armIdle, { passive: true });
      });
      window.addEventListener('scroll', armIdle, { passive: true });
      document.addEventListener('tgsb:reset', resetBuilder);
      // Back from checkout (bfcache) or a fresh load: start clean.
      window.addEventListener('pageshow', function (e) { if (e.persisted) resetBuilder(); });
      clearCart();
    }
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  }
})();
